if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        let that = this;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        var sizecontainer = document.querySelector('.product__size__select');
        if (sizecontainer != null) {
          sizecontainer.addEventListener('click', function (event) {
            if (event.target.classList.contains('size--id')) {
              let orprice =  event.target.getAttribute('data-price');
              let comp = event.target.getAttribute('data-comp_price')
              let orcompprice =  (parseInt(comp) > parseInt(orprice))?comp:orprice;
              let price = parseInt(orprice)/ 100;
              let compprice = parseInt(orcompprice)/ 100;
              const currency = window.Shopify.currency.active || 'EUR';
              const formattedPrice = new Intl.NumberFormat('fr-FR', {
                style: 'currency',
                currency: currency,
                currencyDisplay: 'symbol', // 🔹 Solo muestra el símbolo €
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
                }).format(price);
              const formattedComPrice = new Intl.NumberFormat('fr-FR', {
                style: 'currency',
                currency: currency,
                currencyDisplay: 'symbol', // 🔹 Solo muestra el símbolo €
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
                }).format(compprice);
                var tmpl = '<div class="price__regular"><span class="price-item price-item--regular">'+formattedComPrice+'</span></div>';

              if(orcompprice > orprice){
                document.querySelector('product-info .price').classList.add('price--on-sale')
                let discount = (((orcompprice-orprice)/orcompprice)*100).toFixed(0);
                tmpl += '<div class="price__sale"><span class="price-item price-item--sale" data-sale-price>'+formattedPrice+'<span class="discount">- '+discount+'%</span></span>';

              }else{
                document.querySelector('product-info .price').classList.remove('price--on-sale')
              }
             
              document.querySelector('product-info .price').innerHTML = tmpl;
              
              that.handleErrorMessage(false);
              document.querySelector('.product-form__submit').removeAttribute('disabled');
              let text = document.querySelector('.product-form__submit span').getAttribute('data-t0');
              document.querySelector('.product-form__submit span').innerHTML = text;
            }
          });
        }
        var amountcontainer = document.querySelector('.product__amount__select');
        if (amountcontainer != null) {
          amountcontainer.addEventListener('click', function (event) {
            if (event.target.classList.contains('amount--id')) {
              document.querySelector('.product-form__submit').removeAttribute('disabled');
              let text = document.querySelector('.product-form__submit span').getAttribute('data-t0');
              document.querySelector('.product-form__submit span').innerHTML = text;
            }
          });
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        let that = this;
        if (document.querySelector('.size--id') != null) {
          document.querySelector('.product-variant-id').value = document.querySelector('.size--id:checked').value;
        }

        if (document.querySelector('.amount--id') != null) {
          document.querySelector('.product-variant-id').value = document.querySelector('.amount--id:checked').value;
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              // window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            //console.log(document.querySelector('.size--id:checked'));

            console.error(e);
            that.handleErrorMessage(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        console.log(errorMessage);
        if (errorMessage) {
          this.submitButton.setAttribute('disabled', 'disabled');
          document.querySelector('.size--id:checked').setAttribute('disabled', 'disabled');
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      }
    }
  );
}
